import { render, staticRenderFns } from "./debugDialog.vue?vue&type=template&id=20697d49&scoped=true&"
import script from "./debugDialog.vue?vue&type=script&lang=js&"
export * from "./debugDialog.vue?vue&type=script&lang=js&"
import style0 from "./debugDialog.vue?vue&type=style&index=0&id=20697d49&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20697d49",
  null
  
)

export default component.exports